import { render, staticRenderFns } from "./directorIndex.vue?vue&type=template&id=1b1966da&scoped=true"
import script from "./directorIndex.vue?vue&type=script&lang=js"
export * from "./directorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1966da",
  null
  
)

export default component.exports